module.exports = __webpack_public_path__ + "static/img/icon_grxxtx30.c3302b69.svg";